'use client';

import { BaseLayout } from '@components';
import { NotFoundCard } from '@components/NotFoundCard';

import type { FC } from 'react';

const NotFound: FC = () => {
  return (
    <BaseLayout className="mt-12">
      <NotFoundCard entity="Page" />
    </BaseLayout>
  );
};

export default NotFound;
